import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import Auth from "./authReducer";
import Business from "./businessReducer";
import Saq from "./saqReducer";
import User from "./userReducer";

export default combineReducers({
  router: routerReducer,
  authStore: Auth,
  businessStore: Business,
  saqStore: Saq,
  userStore: User,
});
